let testList = [
    {
        id : '1',
        url: 'Test1',
        testName : 'სიგნალის შემჩნევის ექსპერიმენტი'
    },
    {
        id : '2',
        url: 'Test2',
        testName : 'პერცეფტული შედარება'
    },
    {
        id : '3',
        url: 'Test3',
        testName : 'სტრუპის ეფექტი'
    },
    {
        id : '4',
        url: 'Test4',
        testName : 'სელექციური ყურადღება'
    },
    {
        id : '5',
        url: 'Test5',
        testName : 'ყურადღება: ცვლილებისადმი სიბრმავე'
    },
    {
        id : '6',
        url: 'Test6',
        testName : 'რეაქციის დრო და ყურადღება'
    },
    {
        id : '7',
        url: 'Test7',
        testName : 'მენტალური ხატების როტაცია'
    },
    {
        id : '8',
        url: 'Test8',
        testName : 'ინფორმაციის გადამუშავების პროცესები: ლექსიკური გადაწყვეტილებები'
    },
    {
        id : '9',
        url: 'Test9',
        testName : 'ხანმოკლე მეხსიერების ტესტირება. ცნობის ტესტი'
    },
    {
        id : '10',
        url: 'Test10',
        testName : 'ინფორმაციის გადამუშავების პროცესები ხანგრძლივ მეხსიერებაში. კატეგორიზაცია'
    },
    {
        id : '11',
        url: 'Test11',
        testName : 'მეხსიერების ტესტირების ექსპერიმენტები'
    },
    {
        id : '12',
        url: 'Test12',
        testName : 'ინფორმაციის გადამუშავება: შედარება და რეაქციის სისწრაფე'
    },
    {
        id : '13',
        url: 'Test13',
        testName : 'აზროვნების პროცესის როლი დამახსოვრებაში'
    },
    {
        id : '14',
        url: 'Test14',
        testName : 'სოციალური სტერეოტიპების კვლევა'
    }

];


export default testList;
